import { render } from "./PhoneChatMockup.vue?vue&type=template&id=29ec2e3a&scoped=true"
import script from "./PhoneChatMockup.vue?vue&type=script&lang=js"
export * from "./PhoneChatMockup.vue?vue&type=script&lang=js"

import "./PhoneChatMockup.vue?vue&type=style&index=0&id=29ec2e3a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ec2e3a"]])

export default __exports__